import { render, staticRenderFns } from "./EditLiveCourse.vue?vue&type=template&id=69909624&scoped=true"
import script from "./EditLiveCourse.vue?vue&type=script&lang=ts"
export * from "./EditLiveCourse.vue?vue&type=script&lang=ts"
import style0 from "./EditLiveCourse.vue?vue&type=style&index=0&id=69909624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69909624",
  null
  
)

export default component.exports